import React from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import NewMissionSelector from "components/modify/NewMissionSelector";
import { smallTvT } from "components/modify/default-missions/smallTvT";
import { mediumTvT } from "components/modify/default-missions/mediumTvT";
import { largeTvT } from "components/modify/default-missions/largeTvT";
import { smallPvE } from "components/modify/default-missions/smallPvE";
import { mediumPvE } from "components/modify/default-missions/mediumPvE";
import { largePvE } from "components/modify/default-missions/largePvE";
import { emptyMission } from "components/modify/default-missions/emptyMission";

const DefaultMission = ({
  setMission,
  defaultMissionSelection,
  setDefaultMissionSelection,
  defaultMissionDescription,
  setDefaultMissionDescription,
  username,
}) => {
  return (
    <Container>
      <Typography variant="h5" component="h3">
        DEFAULT MISSION SELECTION
      </Typography>
      <p>
        <b>NOTE:</b> This will override any changes that you have made to the
        mission in the <b>SCHEMA</b> tab.
      </p>
      <div>
        <NewMissionSelector
          value={defaultMissionSelection}
          description={defaultMissionDescription}
          handleChange={(i) => {
            handleNewMissionDefault({
              event: i,
              username,
              setMission,
              setDefaultMissionSelection,
              setDefaultMissionDescription,
            });
          }}
        />
      </div>
    </Container>
  );
};

const handleNewMissionDefault = ({
  event,
  username,
  setMission,
  setDefaultMissionSelection,
  setDefaultMissionDescription,
}) => {
  setDefaultMissionSelection(event.target.value);
  switch (event.target.value) {
    case "emptyMission":
      const ePvP = emptyMission({ username });
      setDefaultMissionDescription(ePvP.description);
      setMission(ePvP.schema);
      return;
    case "smallTvT":
      const sTvT = smallTvT({ username });
      setDefaultMissionDescription(sTvT.description);
      setMission(sTvT.schema);
      return;
    case "mediumTvT":
      const mTvT = mediumTvT({ username });
      setDefaultMissionDescription(mTvT.description);
      setMission(mTvT.schema);
      return;
    case "largeTvT":
      const lTvT = largeTvT({ username });
      setDefaultMissionDescription(lTvT.description);
      setMission(lTvT.schema);
      return;
    case "smallPvE":
      const sPvE = smallPvE({ username });
      setDefaultMissionDescription(sPvE.description);
      setMission(sPvE.schema);
      return;
    case "mediumPvE":
      const mPvE = mediumPvE({ username });
      setDefaultMissionDescription(mPvE.description);
      setMission(mPvE.schema);
      return;
    case "largePvE":
      const lPvE = largePvE({ username });
      setDefaultMissionDescription(lPvE.description);
      setMission(lPvE.schema);
      return;
  }
};

const Container = styled.div`
  width: 100%;
  background: #36393f;
  border-radius: 5px;
  padding: 10px;
`;

export default DefaultMission;
